import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-primary/95 to-secondary min-h-[70vh] flex items-center overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-40 right-1/3 w-20 h-20 border border-white/20 rounded-full"></div>
      </div>

      <div className="relative z-10 w-full px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Content */}
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center space-x-2 bg-accent/20 text-accent-foreground px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Icon name="Zap" size={16} />
                <span>Complete Digital Transformation</span>
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Services Universe
                <span className="block text-accent">Comprehensive Solutions</span>
              </h1>
              
              <p className="text-xl text-white/90 mb-8 max-w-2xl">
                From social media mastery to cutting-edge web development and innovative app creation, 
                we craft digital experiences that transform businesses and captivate audiences.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <Button 
                  variant="default" 
                  className="bg-accent hover:bg-accent/90 text-accent-foreground brand-hover-lift"
                  iconName="Calendar"
                  iconPosition="left"
                >
                  Book Consultation
                </Button>
                <Button 
                  variant="outline" 
                  className="border-white/30 text-white hover:bg-white/10"
                  iconName="Play"
                  iconPosition="left"
                >
                  Watch Our Process
                </Button>
              </div>
            </div>

            {/* Visual Elements */}
            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 brand-hover-lift brand-transition">
                    <Icon name="Share2" size={32} className="text-accent mb-4" />
                    <h3 className="text-white font-semibold mb-2">Social Media Marketing</h3>
                    <p className="text-white/80 text-sm">Strategic campaigns that drive engagement</p>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 brand-hover-lift brand-transition">
                    <Icon name="Code" size={32} className="text-accent mb-4" />
                    <h3 className="text-white font-semibold mb-2">Web Development</h3>
                    <p className="text-white/80 text-sm">Responsive, high-performance websites</p>
                  </div>
                </div>
                <div className="space-y-4 mt-8">
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 brand-hover-lift brand-transition">
                    <Icon name="Smartphone" size={32} className="text-accent mb-4" />
                    <h3 className="text-white font-semibold mb-2">App Development</h3>
                    <p className="text-white/80 text-sm">Native & cross-platform solutions</p>
                  </div>
                  <div className="bg-gradient-to-r from-accent/20 to-accent/10 backdrop-blur-sm rounded-xl p-6 border border-accent/30">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-white font-semibold">Success Rate</span>
                      <span className="text-accent font-bold">98.5%</span>
                    </div>
                    <div className="w-full bg-white/20 rounded-full h-2">
                      <div className="bg-accent h-2 rounded-full w-[98.5%]"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;